export default "__VITE_ASSET__BMpUDKzg__"